import { render, staticRenderFns } from "./OrderItemRow.vue?vue&type=template&id=74eb3883&scoped=true"
import script from "./OrderItemRow.vue?vue&type=script&lang=js"
export * from "./OrderItemRow.vue?vue&type=script&lang=js"
import style0 from "./OrderItemRow.vue?vue&type=style&index=0&id=74eb3883&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74eb3883",
  null
  
)

export default component.exports